<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <div class="pagination-container">
          <el-pagination
            :disabled="isLoading"
            :current-page="listQuery.page"
            :page-sizes="listQuery.sizes"
            :page-size="listQuery.size"
            :total="listQuery.total"
            layout="total, sizes, pager, jumper"
            background
            size="mini"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          />
        </div>
        <!-- <div class="button-container">
          <el-button
            :disabled="isLoading"
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="handleSearch"
          >{{ $t('button.search') }}</el-button>
        </div> -->
      </div>
      <!-- <div class="filter-container">
        <label-wrapper :label="$t('table.store_name')">
          <el-input
            v-model="storeQuery"
            :disabled="isLoading"
            @keyup.enter.native="handleSearch"
          />
        </label-wrapper>
      </div> -->
    </template>

    <el-table
      v-loading="isLoading"
      :data="list"
      stripe
      border
    >
      <el-table-column
        v-for="{ type, ...column } in columnList"
        :key="type"
        :prop="type"
        :label="column.title || $t(`table.${type}`)"
        v-bind="column.custom"
      >
        <template #default="{ row }">
          <template>
            {{ row[type] }}
          </template>
        </template>
      </el-table-column>
    </el-table>
  </sticky-header-layout>
</template>

<script>
import LabelWrapper from '../../components/form/LabelWrapper.vue'
import EditButton from '../../components/buttons/EditButton.vue'

import useTablePaging from '../../mixins/useTablePaging'
import SubscriptionService from '../../api/subscription'

import {
  columnList,
} from '../../const/marketplace/subscriptions'

export default {
  name: 'MarketplaceSubscriptions',
  components: {
    EditButton,
    LabelWrapper,
  },
  mixins: [useTablePaging],
  data() {
    return {
      isLoading: false,
      columnList,
      storeQuery: null,
    }
  },
  mounted() {
    this.handleSearch()
  },
  methods: {
    getPayload() {
      return {
        keywords: this.storeQuery,
        page: this.storeQuery && this.storeQuery.length > 0 ? 1 : this.listQuery.page,
        size: this.listQuery.size,
      }
    },
    async getList() {
      this.isLoading = true
      const payload = this.getPayload()
      try {
        const response = await SubscriptionService.getSubscriptions(payload)
        const { data: newList = [], pagination } = response
        if (Array.isArray(newList)) {
          this.list = newList
        }

        this.listQuery.total = parseInt(pagination.total_items, 0)
      } catch (error) {
        console.log(error);
        this.list = []
      } finally {
        this.isLoading = false
      }
    },
    handleSearch() {
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

.filter-container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-grow: 1;
  .filter-title {
    font-size: 13px;
    margin-right: 5px;
  }
}

</style>

